import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {watch} from 'vue';
import {useMeta} from 'quasar';
import {RouteMeta, useRoute} from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  name: 'App',
  setup(__props) {

const route = useRoute();

watch(() => route.meta,
  (val: RouteMeta) => !!val.title ? useMeta({title: val.title}) : '');

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})